import type { ActivityPlugin } from '../../core/types/activity.types';
import { GAME_MODE_CATALOG } from '../../core/types/gameMode.types';
import { numberLineLogic } from './number_line.logic';
import { NumberLineActivityView } from './NumberLineViews';

export const numberLinePlugin: ActivityPlugin<'number_line'> = {
  ...numberLineLogic,
  displayName: GAME_MODE_CATALOG.number_line.displayName,
  icon: GAME_MODE_CATALOG.number_line.icon,
  HostView: NumberLineActivityView,
  StudentView: NumberLineActivityView,
  ProjectorView: NumberLineActivityView,
};

export { demoNumberLinePayload } from './number_line.logic';
